import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
} from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../constants';
import logoImage from '../assets/Airports_Authority_of_India_logo.svg.png';
import { WebConfig } from '../web-config';

const LoginFail = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    // Redirect to external SSO portal
    window.location.href = `${WebConfig.REACT_APP_AAI_SSO_BASE_URL}`;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: colors.background,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: spacing.lg, md: spacing.xl },
          backgroundColor: colors.backgroundWhite,
          height: '100vh',
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            width: '100%',
            py: 0,
            px: { xs: spacing.md, md: spacing.lg },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: spacing.xl,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                mb: spacing.lg,
                width: '100%',
              }}
            >
              <Box
                component="img"
                src={logoImage}
                alt="Airports Authority of India logo"
                sx={{
                  height: { xs: 44, md: 56 },
                  width: 'auto',
                }}
              />
            </Box>

            <Box
              sx={{
                textAlign: 'center',
                mb: spacing.xl,
              }}
            >
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontSize: { xs: '28px', md: '32px' },
                  fontWeight: fonts.weightBold,
                  color: colors.error,
                  mb: spacing.md,
                  lineHeight: 1.2,
                }}
              >
                Authentication Failed
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: fonts.descriptionSize,
                  color: colors.textSecondary,
                  fontWeight: fonts.weightNormal,
                  lineHeight: 1.5,
                  mb: spacing.lg,
                }}
              >
                SSO authentication failed. Please try again.
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: spacing.md,
                width: '100%',
                maxWidth: '400px',
              }}
            >
              <Button
                fullWidth
                variant="contained"
                onClick={handleRetry}
                sx={{
                  py: spacing.sm,
                  minHeight: '44px',
                  borderRadius: borderRadius.md,
                  background: colors.primaryGradient,
                  color: colors.textWhite || '#ffffff',
                  textTransform: 'none',
                  fontSize: fonts.descriptionSize,
                  fontWeight: fonts.weightSemiBold,
                  letterSpacing: fonts.letterSpacingNormal,
                  boxShadow: `0 12px 24px ${colors.primaryShadow}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: colors.primaryGradientHover,
                    boxShadow: `0 16px 32px ${colors.primaryShadow}`,
                    transform: 'translateY(-2px)',
                    color: colors.textWhite || '#ffffff',
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                    color: colors.textWhite || '#ffffff',
                  },
                }}
              >
                Try Again
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default LoginFail;
